import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { LABEL_TYPES } from "../../../../../lib/label/labelTypes";

import "../styles/default.scss";

const Label = ({
  success,
  error,
  warning,
  type,
  fullWidth,
  className,
  children
}) => (
  <span
    className={classNames({
      "squaber-label": true,
      success,
      error,
      warning,
      "full-width": fullWidth,
      [type]: !!type,
      [className]: !!className
    })}
  >
    {children}
  </span>
);

Label.propTypes = {
  success: PropTypes.bool,
  error: PropTypes.bool,
  warning: PropTypes.bool,
  type: PropTypes.oneOf(LABEL_TYPES),
  fullWidth: PropTypes.bool
};

export default Label;
